import { GridColumnType } from "../../../data/gridColumnType";

export const RequirementApprovalConfig = {
    columns: [
        {
            name: "Channel",
            fieldName: "channelName",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "Requirement Section",
            fieldName: "sgbpRequirmentSectionName",
            colType: GridColumnType.Text,
        },
        {
            name: "Requirement Name",
            fieldName: "requirementName",
            colType: GridColumnType.Text,
        },
        {
            name: "Status",
            fieldName: "status",
            colType: GridColumnType.Text,
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            customWrapper: [
                {
                    name: "VIEW",
                    label: "View",
                },
                // {
                //     name: "ACTIVATE",
                //     label: "Activate",
                // },
                {
                    name: "DEACTIVATE",
                    label: "Deactivate",
                },
            ],
            defaultAction: {
                allowEdit: false,
                allowDelete: false,
            },
        },
    ],
};
